/**
 * Типы ошибок приложения
 */

/** Коды ошибок */
export enum ErrorCode {
  // Сетевые ошибки
  NETWORK_ERROR = 'NETWORK_ERROR',
  TIMEOUT = 'TIMEOUT',
  
  // Ошибки аутентификации
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  
  // Ошибки валидации
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_INPUT = 'INVALID_INPUT',
  
  // Ошибки данных
  NOT_FOUND = 'NOT_FOUND',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  
  // Ошибки Supabase
  RLS_VIOLATION = 'RLS_VIOLATION',
  DATABASE_ERROR = 'DATABASE_ERROR',
  STORAGE_ERROR = 'STORAGE_ERROR',
  
  // Ошибки загрузки файлов
  FILE_TOO_LARGE = 'FILE_TOO_LARGE',
  INVALID_FILE_TYPE = 'INVALID_FILE_TYPE',
  STORAGE_QUOTA_EXCEEDED = 'STORAGE_QUOTA_EXCEEDED',
  
  // Неизвестные ошибки
  UNKNOWN = 'UNKNOWN',
}

/** Базовый интерфейс ошибки приложения */
export interface AppError extends Error {
  code: ErrorCode;
  originalError?: unknown;
  details?: Record<string, unknown>;
}
